import React from 'react';
import { useCurrentUser } from './withUser';
import LoginForm from "../users/LoginForm";
import SingleColumnSection from "./SingleColumnSection";
import { Typography } from "./Typography";
import { StatusCodeSetter } from '../next/StatusCodeSetter';
import { defineStyles } from '../hooks/defineStyles';
import { useStyles } from '../hooks/useStyles';

const styles = defineStyles("ErrorAccessDenied", (theme: ThemeType) => ({
  root: {},
}));

/**
 * Show a simple "you don't have access" message if the user is logged in,
 * or a "please log in" message if the user is logged out.
 *
 * Most of the time, we use this when a page is meant to be accessed by only a subset of
 * logged in users, so by default this prompts the user to log in if they are logged out.
 *
 * However, for pages that are normally meant to be publicly accessible (like the post page),
 * we skip the login prompt and just display the "you don't have access" message.
 */
const ErrorAccessDenied = ({explanation, skipLoginPrompt}: {
  explanation?: string,
  skipLoginPrompt?: boolean,
}) => {
  const currentUser = useCurrentUser();
  const classes = useStyles(styles);

  if (currentUser || skipLoginPrompt) {
    const message = `Sorry, you don't have access to this page.${(explanation ? ` ${explanation}` : "")}`
    return <>
      <StatusCodeSetter status={401}/>
      <SingleColumnSection>
        <Typography variant='body1' className={classes.root}>
          {message}
        </Typography>
      </SingleColumnSection>
    </>
  } else {
    return <>
      <StatusCodeSetter status={401}/>
      <SingleColumnSection>
        <Typography variant='body1' className={classes.root}>
          Please log in to access this page.
        </Typography>
        <LoginForm startingState='login'/>
      </SingleColumnSection>
    </>
  }
}

export default ErrorAccessDenied;


